import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { usersApi, sessionsApi } from '../services/api';

export function EmployeesPage() {
  const [users, setUsers] = useState<any[]>([]);
  const [sessions, setSessions] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [showCreate, setShowCreate] = useState(false);
  const [form, setForm] = useState({ name: '', email: '', password: '', role: 'employee' });

  useEffect(() => {
    Promise.all([usersApi.list(), sessionsApi.getToday()])
      .then(([u, s]) => { setUsers(u); setSessions(s); })
      .finally(() => setLoading(false));
  }, []);

  const getSessionForUser = (userId: number) =>
    sessions.find(s => s.userId === userId && s.status === 'active');

  const handleCreate = async (e: React.FormEvent) => {
    e.preventDefault();
    await usersApi.create(form);
    setShowCreate(false);
    setForm({ name: '', email: '', password: '', role: 'employee' });
    usersApi.list().then(setUsers);
  };

  return (
    <div style={{ padding: '28px 32px' }}>
      <div className="page-header">
        <div>
          <h1 className="page-title">Empleados</h1>
          <p className="page-subtitle">{users.length} empleados activos</p>
        </div>
        <button className="btn btn-primary" onClick={() => setShowCreate(true)}>
          + Nuevo empleado
        </button>
      </div>

      {/* Create form */}
      {showCreate && (
        <div className="card" style={{ marginBottom: 20 }}>
          <h3 style={{ fontSize: 13, fontWeight: 700, marginBottom: 14 }}>Nuevo empleado</h3>
          <form onSubmit={handleCreate} style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
            <input className="input" placeholder="Nombre completo" value={form.name} onChange={e => setForm({...form, name: e.target.value})} required />
            <input className="input" type="email" placeholder="Email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} required />
            <input className="input" type="password" placeholder="Contraseña" value={form.password} onChange={e => setForm({...form, password: e.target.value})} required />
            <select className="input" value={form.role} onChange={e => setForm({...form, role: e.target.value})}>
              <option value="employee">Empleado</option>
              <option value="supervisor">Supervisor</option>
              <option value="admin">Admin</option>
            </select>
            <div style={{ gridColumn: '1/-1', display: 'flex', gap: 8 }}>
              <button type="submit" className="btn btn-primary">Crear</button>
              <button type="button" className="btn btn-secondary" onClick={() => setShowCreate(false)}>Cancelar</button>
            </div>
          </form>
        </div>
      )}

      {/* Table */}
      <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
        <table className="table">
          <thead>
            <tr>
              <th>Empleado</th>
              <th>Rol</th>
              <th>Estado hoy</th>
              <th>Última actividad</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {users.map(user => {
              const session = getSessionForUser(user.id);
              return (
                <tr key={user.id}>
                  <td>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                      <div style={{
                        width: 32, height: 32, borderRadius: '50%',
                        background: 'var(--accent-dim)', color: 'var(--accent)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        fontSize: 12, fontWeight: 700,
                      }}>
                        {user.name?.charAt(0)?.toUpperCase()}
                      </div>
                      <div>
                        <div style={{ fontWeight: 600, fontSize: 13 }}>{user.name}</div>
                        <div style={{ fontSize: 11, color: 'var(--text3)' }}>{user.email}</div>
                      </div>
                    </div>
                  </td>
                  <td>
                    <span className="badge badge-gray">{user.role}</span>
                  </td>
                  <td>
                    {session ? (
                      <span className="badge badge-green">🟢 Trabajando</span>
                    ) : (
                      <span className="badge badge-gray">⚫ Sin fichar</span>
                    )}
                  </td>
                  <td style={{ fontSize: 12, color: 'var(--text3)' }}>
                    {user.lastSeenAt
                      ? new Date(user.lastSeenAt).toLocaleString('es-ES', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' })
                      : 'Nunca'}
                  </td>
                  <td>
                    <Link to={`/employees/${user.id}`} className="btn btn-secondary" style={{ fontSize: 11, padding: '5px 10px' }}>
                      Ver detalle →
                    </Link>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
